const API_SECRET = import.meta.env.VITE_API_SECRET;


export interface AuthHeaders {
    'X-Timestamp': string;
    'X-Signature': string;
    'X-Payload': string;
}

export const generateAuthHeaders = async (payload: string): Promise<AuthHeaders> => {
    const timestamp = new Date().toISOString();
    const signature = await generateHmacSignature(payload, timestamp);
    
    return {
        'X-Timestamp': timestamp,
        'X-Signature': signature,
        'X-Payload': encodeURIComponent(payload)
    };
};

const generateHmacSignature = async (payload: string, timestamp: string): Promise<string> => {
    const message = `${timestamp}.${payload}`;
    const encoder = new TextEncoder();
    const keyData = encoder.encode(API_SECRET);
    const messageData = encoder.encode(message);

    // Import the key
    const key = await crypto.subtle.importKey(
        'raw',
        keyData,
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
    );

    // Generate the signature
    const signature = await crypto.subtle.sign(
        'HMAC',
        key,
        messageData
    );

    return btoa(String.fromCharCode(...new Uint8Array(signature)));
};